import axiosInstance from "./axiosInstance";

// Get all courses
export const fetchCourses = async () => {
    const response = await axiosInstance.get("/course/getall");
    return response.data;
};

export const fetchCourseByCourseId = async (data) => {
    const response = await axiosInstance.get("/course/get", {
        params: data
      });
    return response.data;
};

export const fetchMyCourse = async (data) => {
    const response = await axiosInstance.get("/course/mycourse", {
        params: data
      });
    return response.data;
};

// Create a new course
export const createCourse = async (data) => {
    const response = await axiosInstance.post("/course", data);
    return response.data;
};

// Update a course
export const updateCourse = async ({ id, data }) => {
    const response = await axiosInstance.put(`/course/${id}`, data);
    return response.data;
};

// Delete a course
export const deleteCourse = async (data) => {
    await axiosInstance.delete(`/course`, {
        params: data
    });
};
